import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  console.log("🚀 ~ ProtectedRoute ~ allowedRoles:", allowedRoles)
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("logged_data"))?.user;
  const isAuthenticated = !!userData;
  const userRole = userData?.role;
  console.log("🚀 ~ ProtectedRoute ~ userRole:", userRole)
  
  // Special case - allow direct access to the Secret Subscription page
  if (location.pathname === "/dashboard/8a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d") {
    return children;
  }

  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // If route requires specific roles and user's role is not included
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to="/404" replace />;
  }

  // Redirect chapter_admin from dashboard root to members page
  if (userRole === 'chapter_admin' && location.pathname === '/dashboard') {
    return <Navigate to="/dashboard/members" replace />;
  }

  return children;
};

export default ProtectedRoute; 